<template>
    <el-dialog title="提现申请" :visible.sync="formVisible" :close-on-click-modal="false">
        <el-col :span="24" style="margin-bottom: 20px;">
            <el-form :model="formData" label-width="80px" :rules="formRules" ref="formd">
                <el-form-item label="金额" prop="amt">
                    <el-input v-model="formData.amt" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="formData.desc" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收款码" prop="name">

                    <label>支付宝/微信收款码上传
                        <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png"
                            @change="changeImg($event)">
                    </label>
                    <div class="divEWM">支付宝优先处理</div>
                    <div><img :src="formData.imgs" class="img"></div>

                </el-form-item>
                <div class="divXFTX">
                    <span>友情提醒：根据《中华人民共和国宪法》第56条明确规定，依法纳税是每个公民的基本义务。
                        本平台对作者的收益没有代扣代缴义务，请作者在平台上获得相应的收益后，自行完成纳税义务，
                        如有疑问，可咨询当地12366纳税服务热线处理，特此告知!
                    </span>
                </div>
                <!-- <div>
                    <el-tag type="warning">提现需要收取10%手续费</el-tag>
                </div> -->
            </el-form>
        </el-col>
        <!--工具条-->
        <div slot="footer" class="dialog-footer">
            <el-tag type="warning" style="float: left;">提现需要收取10%服务费</el-tag>
            <el-button @click.native="formVisible = false">取消</el-button>
            <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button>
        </div>
    </el-dialog>
</template>


<script>
var regAmt = /^\d+(\.\d+)?$/;
export default {
    data() {
        return {
            formVisible: false,
            formLoading: false,
            formRules: {
                amt: [
                    { required: true, message: '请输入金额' },
                    {
                        validator: (rule, value, callback) => {
                            try {
                                if (value == '') {
                                    callback(new Error('请输入金额!'));
                                } else if (regAmt.test(value)) {
                                    let amt = parseFloat(value);
                                    if (amt < 100)
                                        callback(new Error('最少提100元'));
                                    else if (amt > 50000)
                                        callback(new Error('最多提50000元'));
                                    else
                                        callback();
                                } else
                                    callback(new Error('格式错误：必须是 "数字"'));
                            } catch (e) {
                                callback(new Error('格式错误!:必须是 "金额"'));
                            }
                        }
                    }
                ]
            },
            //新增界面数据
            formData: {}
        }
    },
    mounted() {
        // this.getLastImg();
    },
    methods: {
        show() {
            this.formVisible = true;
            this.formData = {
                xid: '',
                amt: '',
                desc: ''
            }
            this.getLastImg();
        },
        /*handleSelect:function(id){
                        this.tmpltCont='';
                        if(id==''){
                            return
                        }
                        let it=this.tmplatdatas[id];
                        if(it==null){
                            return
                        }
                        //console.log("123",this.tmplatdatas[id]);
                        this.tmpltCont=it.Content;
                        this.tmpltmapls=[];
                        SmsTmpltKeys(id).then(res=>{
                            for(let i in res.data){
                                this.tmpltmapls.push({
                                    key:res.data[i],value:''
                                });
                            }
                        });
                    },*/
        formSubmit() {
            this.$refs.formd.validate((valid) => {
                if (valid) {
                    let regd = /^(data:image).+/;
                    if (this.formData.xid == '' && this.formData.imgid == '' && !regd.test(this.formData.imgs)) {
                        this.$message({
                            message: '请选择收款码图片',
                            type: 'error'
                        });
                        return;
                    }
                    this.formLoading = true;
                    this.$post('/user/tx', this.formData).then(res => {
                        console.log(res);
                        this.$emit('submitOK');
                        this.formLoading = false;
                        this.formVisible = false;
                        //this.$message('操作成功');
                    }).catch(err => {
                        this.$emit('submitErr', err);
                        this.formLoading = false;
                        //this.formVisible = false;
                        this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        },
        changeImg(e) {
            let file = e.target.files[0]
            if (file.size > 1 * 1024 * 1024) {
                this.$message({
                    message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过1M',
                    type: 'error'
                });
                return;
            }
            let that = this
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function (e) {
                that.formData.imgid = '';
                that.formData.imgs = this.result;
                that.$forceUpdate();
                // console.log('imgs',that.formData.imgs)
            }
        },
        getLastImg() {
            this.formLoading = true;
            this.$post('/user/tximg').then(res => {
                this.formLoading = false;
                this.formData.imgid = res.data.Id;
                this.formData.imgs = res.data.Imgs;
            }).catch(err => {
                this.formLoading = false;
                /*this.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });*/
            });
        }
    }
};
</script>

<style scoped>
.tmpdesc {
    margin-left: 10px;
    color: #d0d0d0;
}

.img {
    width: 250px;
    height: 350px;
}

.divEWM {
    font-size: 12px;
    color: #f30;
}

.divXFTX {
    padding-left: 20px;
    font-size: 12px;
    color: #aaa;
}
</style>



// WEBPACK FOOTER //
// txEdit.vue?2950dd84